module.exports = __webpack_public_path__ + "img/lgt.275e8f30.svg";